import React from "react";
import { motion } from "framer-motion";
import { Card } from "../../../components/ui/card";
import { Navigate, useNavigate } from "react-router-dom";
import { Skeleton } from "src/components/ui/skeleton";
import { UrlImage } from "../../../lib/api";

export default function TeacherCard({ teachers = [1, 2, 3, 4], loading }) {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {loading
        ? Array(3)
            .fill()
            .map((_, index) => (
              <Skeleton key={index} className="w-full h-[400px]" />
            ))
        : teachers.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              onClick={() =>
                navigate("/teacher-info", { state: { teacher: item } })
              }
            >
              <Card className="bg-blue-600 h-[400px] relative cursor-pointer hover:scale-105 transition-transform overflow-hidden">
                <img
                  src={`${UrlImage}${item.image}`}
                  alt={item.name}
                  className="object-cover object-right w-full h-full"
                />

                <div className="absolute end-2 bottom-2 shadow-md bg-white text-black rounded-md px-2 py-1 text-center">
                  <div className="text-base font-bold">{item.name}</div>
                  <div className="text-xs font-semibold text-muted-foreground">
                    {item.phone}
                  </div>
                </div>
              </Card>
            </motion.div>
          ))}
    </div>
  );
}
